import * as React from 'react'
import * as cn from 'classnames'
import { mutedButton, unmutedButton, fullscreenButton, exitFullscreenButton } from './Buttons'
import { VideoContextType } from "../videoContext";
import { safeBool } from '@utils'
import * as styles from './Controls.module.scss'
import { DraperPlayerPlacement } from '../types';

export interface DraperPlayerControlsProps {
    disableUnmute?: boolean
    toggleMute: (event: React.MouseEvent) => void
    enableFullscreen: boolean
    toggleFullscreen: (event: React.MouseEvent) => void
    videoContext: VideoContextType,
    placement: DraperPlayerPlacement
}

export const DraperPlayerControls = (props: DraperPlayerControlsProps) => {
    const showMuteToggle = !safeBool(props.disableUnmute)

    if (!showMuteToggle && !props.enableFullscreen) {
        return null
    }

    return <div className={cn(styles.playerControls, {[styles.packshot]: props.placement === DraperPlayerPlacement.Packshot})}>
      {(showMuteToggle && props.videoContext.muted) ? <button key={'unmute'} onMouseDown={props.toggleMute}
        className={'tst-video-overlay-player-muted'}>{mutedButton}</button> : undefined}

      {(showMuteToggle && !props.videoContext.muted) ? <button key={'mute'} onMouseDown={props.toggleMute}
        className={'tst-video-overlay-player-unmuted'}>{unmutedButton}</button> : undefined}

      {props.enableFullscreen && !props.videoContext.fullScreen ?
        <button className={'tst-video-overlay-player-fullscreen'} key={'fullscreen'} onMouseDown={props.toggleFullscreen}>
          {fullscreenButton}
        </button> : undefined}

      {props.enableFullscreen && props.videoContext.fullScreen ?
        <button className={'tst-video-overlay-player-exit-fullscreen'} key={'exit-fullscreen'} onMouseDown={props.toggleFullscreen}>
          {exitFullscreenButton}
        </button> : undefined}
    </div>
    
}